module.exports = __webpack_public_path__ + "images/emoji/japanese_ogre.182ac547a69ae30a4602.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/japanese_ogre.png
// module id = rXoe
// module chunks = 14